import { PropsWithChildren } from 'react';
import styles from './error-text.module.css';

export const ErrorText = ({ children }: PropsWithChildren) => {
  return <span className={styles.errorText}>{children}</span>;
};
